/* Piece Verse related products: slots Product Recommendations API results after the same-series cards. */
if (!customElements.get('bk-related-products')) {
  customElements.define(
    'bk-related-products',
    class BkRelatedProducts extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-bk-related-list]');
        this.limit = parseInt(this.dataset.limit, 10) || 4;
        if (!this.list || !this.dataset.url || !this.dataset.productId) return;
        // Enough same-series products already rendered, no request needed.
        if (this.list.querySelectorAll('[data-bk-source="series"]').length >= this.limit) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async load() {
        const params = new URLSearchParams({
          product_id: this.dataset.productId,
          limit: String(this.limit),
          section_id: this.dataset.sectionId,
          intent: 'related',
        });
        try {
          const response = await fetch(`${this.dataset.url}?${params}`);
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          this.merge(Array.from(doc.querySelectorAll('li[data-product-id]')));
        } catch (error) {
          // Server-rendered series + fallback cards stay in place.
          console.error(error);
        }
      }

      merge(incoming) {
        if (incoming.length === 0) return;
        const existing = new Set(
          Array.from(this.list.children)
            .filter((li) => li.dataset.bkSource !== 'fallback')
            .map((li) => li.dataset.productId)
        );
        const lastSeries = Array.from(this.list.querySelectorAll('[data-bk-source="series"]')).pop();
        let anchor = lastSeries || null;

        incoming.forEach((item) => {
          if (existing.has(item.dataset.productId)) return;
          existing.add(item.dataset.productId);
          const node = document.importNode(item, true);
          if (anchor) anchor.after(node);
          else this.list.prepend(node);
          anchor = node;
        });

        // Drop duplicates of API items that were already rendered as fallback, then trim to the limit.
        const seen = new Set();
        Array.from(this.list.children).forEach((li) => {
          if (seen.has(li.dataset.productId)) li.remove();
          else seen.add(li.dataset.productId);
        });
        Array.from(this.list.children)
          .slice(this.limit)
          .forEach((li) => li.remove());
        this.hidden = this.list.children.length === 0;
      }
    }
  );
}
